/**
 * Search component.
 * @module components/theme/Search/Search
 */

import Search from 'design-comuni-plone-theme/components/ItaliaTheme/Search/Search';

export default Search;
